/* FTB - The Vault: image hover/colour swap, vote + email capture, progress toward the goal */
(function () {

  /* ---- card imagery: back of the item on hover, colour dots swap the shot ---- */
  function wireImages(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('.ftb-vt__card'));

    cards.forEach(function (card) {
      var main = card.querySelector('.ftb-vt__img');
      var alt = card.querySelector('.ftb-vt__alt');
      if (!main) return;

      var baseFront = main.getAttribute('data-front') || main.getAttribute('src') || '';
      var baseBack = alt ? (alt.getAttribute('data-back') || '') : '';
      var dots = Array.prototype.slice.call(card.querySelectorAll('.ftb-vt__dot'));
      var sticky = false;

      function show(front, back) {
        if (front && main.getAttribute('src') !== front) main.setAttribute('src', front);
        if (!alt) return;
        if (back) {
          if (alt.getAttribute('src') !== back) alt.setAttribute('src', back);
        } else {
          alt.removeAttribute('src');
        }
      }

      /* The dot whose colour the card is showing at rest. The featured image is
         normally one colourway's front shot, so match on it; if the archive
         photo is a group shot that matches nothing, fall back to the first dot
         rather than leaving the row unringed. Same rule the collection cards
         use, so the two read the same way. */
      var baseDot = null;
      dots.forEach(function (d) {
        if (!baseDot && d.getAttribute('data-img') === baseFront) baseDot = d;
      });
      if (!baseDot) baseDot = dots[0] || null;

      function ring(dot) {
        dots.forEach(function (d) { d.classList.remove('is-on'); });
        if (dot) dot.classList.add('is-on');
      }

      function apply(dot) {
        ring(dot);
        show(dot.getAttribute('data-img') || baseFront, dot.getAttribute('data-back') || '');
      }

      function reset() {
        ring(baseDot);
        show(baseFront, baseBack);
      }

      ring(baseDot);

      dots.forEach(function (dot) {
        dot.addEventListener('mouseenter', function () { if (!sticky) apply(dot); });
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (dot.classList.contains('is-on') && sticky) { sticky = false; reset(); return; }
          sticky = true;
          apply(dot);
        });
        dot.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            sticky = true;
            apply(dot);
          }
        });
      });

      /* Hovering a dot also hovers the card, so the back-of-item overlay would
         cover the colour the visitor just picked. Suppress it while the pointer
         is on the swatch row; moving back onto the photo shows the back again. */
      var sw = card.querySelector('.ftb-vt__sw');
      if (sw) {
        sw.addEventListener('mouseenter', function () { card.classList.add('is-swatching'); });
        sw.addEventListener('mouseleave', function () { card.classList.remove('is-swatching'); });
        sw.addEventListener('focusin', function () { card.classList.add('is-swatching'); });
        sw.addEventListener('focusout', function () { card.classList.remove('is-swatching'); });
      }

      card.addEventListener('mouseleave', function () {
        card.classList.remove('is-swatching');
        if (!sticky) reset();
      });
    });
  }

  /* ---- voting ---- */
  function init(root) {
    if (!root || root.__ftbVaultReady) return;
    root.__ftbVaultReady = true;

    wireImages(root);

    var api = (root.getAttribute('data-vote-api') || '').trim();
    var goal = parseInt(root.getAttribute('data-goal'), 10) || 100;
    var openLabel = root.getAttribute('data-open-label') || 'Notify me';
    var votedLabel = root.getAttribute('data-voted-label') || 'Voted';
    var openCount = root.getAttribute('data-open-count') || "It's happening";
    var firstLabel = root.getAttribute('data-first-label') || 'Be the first';
    var togoWord = root.getAttribute('data-togo-word') || 'to go';
    /* The unit beside the number. Singular is derived by stripping a trailing
       s rather than by adding a second setting, so "votes" gives "vote" and a
       word that is already singular is left alone. */
    var votesWord = root.getAttribute('data-votes-word') || 'votes';
    var voteWordOne = votesWord.replace(/s$/i, '') || votesWord;
    /* The six messages under the form come from the section's Voting settings
       (data-msg-*). These fallbacks match the saved wording, so a page that
       does not pass them, like the Vault product page today, still reads the
       same. [goal] in the success line becomes the vote target. */
    var msgBad = root.getAttribute('data-msg-bad') || "That email doesn't look right.";
    var msgSending = root.getAttribute('data-msg-sending') || 'Sending.';
    var msgOk = root.getAttribute('data-msg-ok') || "You're in. We'll email you the pre-order link if it hits [goal] votes.";
    /* hasAttribute, not ||, so a blank setting can switch this line off. */
    var msgJoined = root.hasAttribute('data-msg-joined') ? root.getAttribute('data-msg-joined') : "You're on the list too.";
    var msgDupe = root.getAttribute('data-msg-dupe') || "You've already voted for this one.";
    var msgError = root.getAttribute('data-msg-error') || "Couldn't record that vote. Try again shortly.";
    var cards = Array.prototype.slice.call(root.querySelectorAll('.ftb-vt__card'));

    if (!api) {
      cards.forEach(function (c) {
        ['.ftb-vt__meter', '.ftb-vt__form', '.ftb-vt__msg'].forEach(function (sel) {
          var el = c.querySelector(sel);
          if (el) el.style.display = 'none';
        });
      });
      return;
    }

    function sep(u) { return u.indexOf('?') > -1 ? '&' : '?'; }

    /* Which pieces this browser has already voted for. The server is the real
       record; this only exists so a returning visitor is not invited to vote a
       second time and then told off for it. Wrapped because Safari private
       browsing throws on localStorage rather than returning null. */
    var VOTED_KEY = 'ftbVaultVoted';

    function votedList() {
      try {
        var raw = window.localStorage.getItem(VOTED_KEY);
        var arr = raw ? JSON.parse(raw) : [];
        return Object.prototype.toString.call(arr) === '[object Array]' ? arr : [];
      } catch (e) { return []; }
    }

    function rememberVote(handle) {
      try {
        var arr = votedList();
        if (arr.indexOf(handle) === -1) {
          arr.push(handle);
          window.localStorage.setItem(VOTED_KEY, JSON.stringify(arr));
        }
      } catch (e) { /* no memory available, the vote still counted */ }
    }

    /* Quiet the button: stays in place so the row does not reflow, but goes
       grey, loses its label and stops responding. */
    function markVoted(card) {
      var btn = card.querySelector('.ftb-vt__btn');
      var form = card.querySelector('.ftb-vt__form');
      if (form) form.classList.remove('is-open');
      if (!btn) return;
      card.setAttribute('data-voted', '1');
      btn.classList.add('is-voted');
      btn.setAttribute('aria-disabled', 'true');
      btn.textContent = votedLabel;
    }

    /* The meter reads as ten blocks of ten because the track is masked into
       segments in CSS, not because the fill snaps. So the bar still reports the
       true number: 12 votes is 1.2 blocks, not 1. The number leads, and the
       label counts DOWN, because "88 to go" asks for something and "12 of 100"
       only reports. At zero it invites instead. */
    function paint(card, n) {
      n = parseInt(n, 10) || 0;
      var fill = card.querySelector('.ftb-vt__fill');
      var count = card.querySelector('.ftb-vt__count');
      var togo = card.querySelector('.ftb-vt__togo');
      var unit = card.querySelector('.ftb-vt__unit');
      var btn = card.querySelector('.ftb-vt__btn');
      var pct = Math.max(0, Math.min(100, (n / goal) * 100));
      var open = n >= goal;

      if (fill) fill.style.width = pct + '%';
      card.classList.toggle('is-open', open);
      if (count) count.textContent = n;
      if (unit) unit.textContent = (n === 1 ? voteWordOne : votesWord);
      /* The countdown number is wrapped so CSS can give it the same Anton
         display size as the count on the left. Built as nodes, not as an HTML
         string, so a theme setting cannot inject markup. The zero-vote and
         goal-reached labels carry no number and stay plain. */
      if (togo) {
        if (open || n === 0) {
          togo.textContent = open ? openCount : firstLabel;
        } else {
          togo.textContent = '';
          var tnum = document.createElement('span');
          tnum.className = 'ftb-vt__togonum';
          tnum.textContent = goal - n;
          togo.appendChild(tnum);
          togo.appendChild(document.createTextNode(' ' + togoWord));
        }
      }
      /* Once they have voted, the voted label wins. They have already given us
         their email, so "Notify me" would be asking for something they did. */
      if (btn && open && card.getAttribute('data-voted') !== '1') btn.textContent = openLabel;
      card.setAttribute('data-votes', n);
    }

    function loadCounts() {
      fetch(api + sep(api) + 'action=counts', { method: 'GET' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var counts = (d && d.counts) ? d.counts : (d || {});
          cards.forEach(function (card) {
            paint(card, counts[card.getAttribute('data-handle')] || 0);
          });
        })
        .catch(function () { /* counts stay at zero, the page still works */ });
    }

    function valid(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
    }

    /* text/plain keeps this a simple request, so no CORS preflight, which
       Apps Script cannot answer. Do not change the content type. */
    function send(handle, email, marketing) {
      return fetch(api, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify({
          action: 'vote',
          item: handle,
          email: email,
          marketing: marketing === true,
          source: 'vault'
        })
      }).then(function (r) { return r.json(); });
    }

    var already = votedList();

    cards.forEach(function (card) {
      var btn = card.querySelector('.ftb-vt__btn');
      var form = card.querySelector('.ftb-vt__form');
      var input = card.querySelector('.ftb-vt__email');
      var go = card.querySelector('.ftb-vt__send');
      var optin = card.querySelector('.ftb-vt__optin');
      var msg = card.querySelector('.ftb-vt__msg');
      var handle = card.getAttribute('data-handle');
      if (!btn || !form || !input || !go) return;

      if (already.indexOf(handle) > -1) markVoted(card);

      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-voted')) return;
        if (form.classList.toggle('is-open')) input.focus();
      });

      function submit() {
        var email = (input.value || '').trim();
        if (!valid(email)) {
          msg.className = 'ftb-vt__msg is-err';
          msg.textContent = msgBad;
          return;
        }
        go.disabled = true;
        msg.className = 'ftb-vt__msg';
        msg.textContent = msgSending;
        var wantsList = !!(optin && optin.checked);
        send(handle, email, wantsList).then(function (d) {
          if (d && d.ok) {
            /* Mark voted BEFORE painting, so paint leaves the voted label alone
               on a card that has just crossed the goal. */
            rememberVote(handle);
            markVoted(card);
            paint(card, d.count);
            msg.className = 'ftb-vt__msg is-ok';
            /* Say out loud that they joined the list, so the checkbox never
               feels like something that happened to them quietly. */
            var joined = wantsList && !d.duplicate && msgJoined ? ' ' + msgJoined : '';
            msg.textContent = d.duplicate
              ? msgDupe
              : msgOk.split('[goal]').join(String(goal)) + joined;
            input.value = '';
            if (optin) optin.checked = false;
          } else {
            msg.className = 'ftb-vt__msg is-err';
            msg.textContent = msgError;
          }
        }).catch(function () {
          msg.className = 'ftb-vt__msg is-err';
          msg.textContent = msgError;
        }).then(function () { go.disabled = false; });
      }

      go.addEventListener('click', submit);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); submit(); }
      });
    });

    loadCounts();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('.ftb-vault')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
